import { Button } from '../Button';
import { ChevronLeft } from '../Icons';
import { usePagination } from '../Table/hooks';

type PaginationProps = {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
};

export const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
}: PaginationProps) => {
  const {
    pageIndex,
    nextDisabled,
    prevDisabled,
    handleNextPage,
    handlePrevPage,
    handlePageChange,
  } = usePagination(currentPage, totalPages, onPageChange);

  return (
    <div className="flex w-full justify-center gap-1.25">
      <Button variant="gray" isDisabled={prevDisabled} onClick={handlePrevPage}>
        <ChevronLeft />
      </Button>
      {Array.from({ length: totalPages }, (_, i) => i).map((page) => {
        return (
          <Button
            className={
              pageIndex === page + 1 ? 'bg-primaryBlue text-white' : ''
            }
            key={page}
            variant="gray"
            onClick={() => handlePageChange(page + 1)}
          >
            {page + 1}
          </Button>
        );
      })}
      <Button variant="gray" isDisabled={nextDisabled} onClick={handleNextPage}>
        <ChevronLeft className="rotate-180 transform" />
      </Button>
    </div>
  );
};
